import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9b53e6ca"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "profile-container"
};
const _hoisted_2 = {
  class: "flex-container"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-item"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "block profile-text"
}, "Account information"), /*#__PURE__*/_createElementVNode("span", {
  class: "block profile-text-info"
}, "Provide your basic details")], -1));
const _hoisted_4 = {
  class: "flex-item flex-item priority-high"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_workspace_information = _resolveComponent("workspace-information");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_workspace_information)])])]);
}